// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".searchWrapper--13aHxhPC {\n  margin-top: 10px;\n  margin-bottom: 20px;\n  padding: 0 15px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchWrapper": "searchWrapper--13aHxhPC"
};
export default ___CSS_LOADER_EXPORT___;
